import React from "react";

export default function DragIcon() {
  return (
    <svg
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.05025 3.59025C1.42153 3.59429 0.852653 3.21814 0.610181 2.63804C0.36771 2.05795 0.499684 1.38884 0.944264 0.944264C1.38884 0.499684 2.05795 0.36771 2.63804 0.610181C3.21814 0.852653 3.59429 1.42153 3.59025 2.05025C3.59025 2.90077 2.90077 3.59025 2.05025 3.59025Z"
        fill="#92A2B1"
      />
      <path
        d="M10.0502 3.59025C9.42153 3.59429 8.85265 3.21814 8.61018 2.63804C8.36771 2.05795 8.49968 1.38884 8.94426 0.944264C9.38884 0.499684 10.0579 0.36771 10.638 0.610181C11.2181 0.852653 11.5943 1.42153 11.5902 2.05025C11.5902 2.90077 10.9008 3.59025 10.0502 3.59025Z"
        fill="#92A2B1"
      />
      <path
        d="M2.05025 9.59025C1.42153 9.59429 0.852653 9.21814 0.610181 8.63804C0.36771 8.05795 0.499684 7.38884 0.944264 6.94426C1.38884 6.49968 2.05795 6.36771 2.63804 6.61018C3.21814 6.85265 3.59429 7.42153 3.59025 8.05025C3.59025 8.90077 2.90077 9.59025 2.05025 9.59025Z"
        fill="#92A2B1"
      />
      <path
        d="M10.0502 9.59025C9.42153 9.59429 8.85265 9.21814 8.61018 8.63804C8.36771 8.05795 8.49968 7.38884 8.94426 6.94426C9.38884 6.49968 10.0579 6.36771 10.638 6.61018C11.2181 6.85265 11.5943 7.42153 11.5902 8.05025C11.5902 8.90077 10.9008 9.59025 10.0502 9.59025Z"
        fill="#92A2B1"
      />
      <path
        d="M2.05025 15.5902C1.42153 15.5943 0.852653 15.2181 0.610181 14.638C0.36771 14.0579 0.499684 13.3888 0.944264 12.9443C1.38884 12.4997 2.05795 12.3677 2.63804 12.6102C3.21814 12.8527 3.59429 13.4215 3.59025 14.0502C3.59025 14.9008 2.90077 15.5902 2.05025 15.5902Z"
        fill="#92A2B1"
      />
      <path
        d="M10.0502 15.5902C9.42153 15.5943 8.85265 15.2181 8.61018 14.638C8.36771 14.0579 8.49968 13.3888 8.94426 12.9443C9.38884 12.4997 10.0579 12.3677 10.638 12.6102C11.2181 12.8527 11.5943 13.4215 11.5902 14.0502C11.5902 14.9008 10.9008 15.5902 10.0502 15.5902Z"
        fill="#92A2B1"
      />
    </svg>
  );
}
